import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";

const Component = loadable(() =>
  import("@lexus.com/ui/dist/components/SpecsHighlight")
);

const ComponentEditConfig = {
  emptyLabel: "Specs Highlight",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const formatToPx = (value) => {
  if (value === undefined || value === null) return value;

  return `${value}px`;
}

const transformData = (props) => ({
  component: "SpecsHighlight",
  props: {
    ...props,
    backgroundColor: props?.componentDesign?.backgroundColor,
    backgroundOpacity: Number(props?.componentDesign?.backgroundOpacity) || 0,
    textColor: props?.fontColor,
    media: props?.componentDesign?.backgroundMedia,
    specs: props?.specs?.map((spec) => ({
      label: spec?.specType,
      subDescription: spec?.subSpec,
      value: spec?.mainSpec,
      description: spec?.specDescription,
      media: spec?.media,
      ctas: spec?.ctas,
      fontSize: spec?.fontSize,
    })),
    contentWidth: props?.componentDesign?.contentWidth,
    marginTop: formatToPx(props?.componentDesign?.marginTop),
    marginRight: formatToPx(props?.componentDesign?.marginRight),
    marginBottom: formatToPx(props?.componentDesign?.marginBottom),
    marginLeft: formatToPx(props?.componentDesign?.marginLeft),
    paddingTop: formatToPx(props?.componentDesign?.paddingTop),
    paddingRight: formatToPx(props?.componentDesign?.paddingRight),
    paddingBottom: formatToPx(props?.componentDesign?.paddingBottom),
    paddingLeft: formatToPx(props?.componentDesign?.paddingLeft),
  },
});

const SpecsHighlight = (props) => {
  const data = transformData(props);
  return <Component {...data.props} />;
};

export default withAemIntegration("lexus/components/content/specs-highlight")(
  SpecsHighlight,
  ComponentEditConfig
);
